import { observable, makeObservable, action } from 'mobx'
import i18n from 'i18next'
import * as R from 'ramda'
import moment from 'moment'

import surveyApi from '../../API/Survey'
import { SurveyUser } from '../../Models/SurveyUser'
import {
    CountryListQuestion,
    DropdownListQuestion,
    GridQuestion,
    MultipleChoiceQuestion,
    NumericQuestion,
    PercentageQuestion,
    PriorityQuestion,
    RatingQuestion,
    SingleChoiceQuestion,
    StaticText,
    TextAreaQuestion,
    TextBoxQuestion,
    SmartGridQuestion,
    UrlVariableQuestion,
    TextBoxListQuestion,
    FormQuestion,
    NumberFormQuestion,
    DateQuestion,
} from '../../Models/Question'

class DistributeStore {
    scheduleId = 0

    showSetAsTemplate = false

    @observable activeTab = 'builder'

    @observable navigationActiveTab = ''

    @observable emailListModalVisible = false

    @observable addToQuestionModalVisible = false

    @observable previewModalVisible = false

    @observable createUserModalVisible = false

    @observable completionModalVisible = false

    @observable downloadModalVisible = false

    @observable errorModalVisible = false

    @observable deleteSelectedModalVisible = false

    // ACCORDIONS
    @observable uploadInfoAccordionOpen = true

    @observable uploadStatsAccordionOpen = true

    @observable previewDataAccordionOpen = 'preview'

    @observable emailListModalLoading = false

    @observable downloadModalLoading = false

    @observable stage = 'list'

    @observable state = 'loading'

    @observable createEmailModalVisible = false

    @observable sendFromWarningModalVisible = false

    @observable testEmailModalVisible = false

    @observable surveyLinkWarningModalVisible = false

    @observable optOutLinkWarningModalVisible = false

    @observable scheduleEmailModalVisible = false

    @observable sendNowModalVisible = false

    @observable emailListWarningModalVisible = false

    @observable verificationWarningModalVisible = false

    @observable wizardEmailModalVisible = false

    @observable emailListMergeFieldModalVisible = false

    @observable deleteUsersFromListModalVisible = false

    @observable deleteUsersFromListConfirmationModalVisible = false

    @observable createEmailListModalVisisble = false

    @observable deleteListModalVisible = false

    @observable listToDelete = null

    @observable optOutChecked = false

    @observable saveAsTemplate = false

    @observable readOnly = false

    @observable scheduleEmailChecked = false

    @observable ignoreOptoutWarning = false

    @observable testEmailAddress = ''

    emailBody = ''

    @observable emailReplyTo = ''

    @observable template = ''

    @observable scheduleStatus = ''

    @observable addReplyTo = false

    @observable emailSender = ''

    @observable emailSubject = ''

    @observable banner = ''

    @observable userFilterText = ''

    @observable listsFilterText = ''

    @observable usersToDelete = []

    @observable usersToDeleteCount = 0

    @observable emailList = []

    @observable emailListOptions = []

    @observable scheduleUserLists = []

    @observable filteredListList = []

    @observable filteredUserList = []

    @observable scheduleList = []

    @observable selectedEmailSendDateTime = moment().add(1, 'days').startOf('day')

    @observable emailSubjectKey = new Date().getTime()

    @observable disableEmailSender = true

    @observable invalidTestEmail = false

    @observable dragActive = false

    @observable selectedStatusFilter

    @observable page = 1

    // COUNTS
    @observable optOutCount = 0

    @observable invalidCount = 0

    @observable totalCount = 0

    @observable rowCount = 0

    @observable pageCount = 1

    @observable windowCount = 0

    @observable records = ''

    @observable listName = ''

    @observable verifyEmail = false

    @observable confirmationChecked = false

    @observable surveyQuestions = []

    @observable addedQuestions = []

    @observable selectedQuestion = {}

    @observable emailSchedule = []

    @observable uploadDetails = observable.map({})

    @observable uploadDelimiter = 'comma'

    @observable mandatoryQuestions = []

    @observable selectedEmailSchedule = {
        value: '',
        label: 'All',
    }

    @observable userDownloadUrl = ''

    @observable previewFilteredList = []

    @observable selectedEmailList = {
        value: '',
        label: 'All',
    }

    @observable questionTargets = observable.map({})

    @observable fileTargets = []

    @observable columns = observable.map({
        email: [],
        firstname: [],
        lastname: [],
        salutation: [],
        companyname: [],
        jobtitle: [],
    })

    @observable userData = {
        email: '',
        salutation: '',
        firstname: '',
        lastname: '',
        jobtitle: '',
        companyname: '',
        type: 1,
    }

    @observable errorType = ''

    @observable errorDetails = {}

    @observable errorMsg = ''

    @observable userList = []

    @observable importDetails = {
        numSurveyUsers: 0,
        emailDuplicatesInFile: [],
        emailDuplicatesInDb: [],
        emailsInBlacklist: [],
    }

    @observable downloadType = ''

    @observable downloadDelimiter = 'comma'

    @observable selectedUsers = []

    statusFilterOptions = [
        {
            label: 'All statuses',
            value: 'all',
        },
        {
            label: 'Completed',
            value: 'completed',
        },
        {
            label: 'Draft',
            value: 'draft',
        },
        {
            label: 'Paused',
            value: 'paused',
        },
        {
            label: 'Cancelled',
            value: 'cancelled',
        },
        {
            label: 'Scheduled',
            value: 'scheduled',
        },
    ]

    defaultStatusFilter = {
        label: 'All statuses',
        value: 'all',
    }
    
    emailTemplates = [
        {
          value: -1,
          label: i18n.t('--none--'),
          isDisabled: true,
        },
    ]

    editingUser = false

    userTypes = [1, -1]

    optedOut = false

    @observable invalid = false

    statusFilters = []

    selectedEmailList = {
        label: 'Please select...',
        value: '',
    }

    @observable selectedCreateUserList = {
        label: 'Please select...',
        value: '',
    }

    questionTypeMap = {
        CH: 'Multiple Choice',
        CO: 'Country list',
        I: 'Number Range',
        OD: 'Priority',
        PC: 'Percent',
        RD: 'Single Choice',
        RT: 'Ratings',
        SB: 'Drop-down List',
        ST: 'Static Text',
        TA: 'Text Area',
        TB: 'Grid',
        TX: 'Text Box',
    }

    defaultSelectedQuestion = {
        label: 'Select a question',
        value: -1,
    }

    modalDataMap = {
        campaign: {
            title: i18n.t('distributionDeleteModal.campaignTitle'),
            body: i18n.t('distributionDeleteModal.campaignBody'),
        },
        embed: {
            title: i18n.t('distributionDeleteModal.websiteTitle'),
            body: i18n.t('distributionDeleteModal.websiteBody'),
        },
        intercept: {
            title: i18n.t('distributionDeleteModal.websiteTitle'),
            body: i18n.t('distributionDeleteModal.websiteBody'),
        },
        onsite: {
            title: i18n.t('distributionDeleteModal.onsiteTitle'),
            body: i18n.t('distributionDeleteModal.onsiteBody'),
        },
        qr: {
            title: i18n.t('distributionDeleteModal.qrTitle'),
            body: i18n.t('distributionDeleteModal.qrBody'),
        },
    }

    @observable campaignModalVisible = false

    @observable kioskSettingsModalVisible = false

    @observable deleteModalVisisble = false

    @observable deleteModalItem = ''

    @observable deleteModalData = {
        title: i18n.t('distributionDeleteModal.campaignTitle'),
        body: i18n.t('distributionDeleteModal.campaignBody'),
    }

    @observable campaignTitle = ''

    @observable helperVisible = false

    @observable showEmbedWarning = false

    @observable campaignType = ''

    @observable filterText = ''

    @observable showCampaign = false

    @observable isEditingSource = false

    @observable campaignError = false

    @observable domainError = false

    @observable missingProtocol = false

    @observable localeError = false

    @observable importProcessing = false

    @observable filteredList = []

    @observable prePopulatedResponses = observable.map({})

    @observable selectedLocale = {
        label: i18n.t('form.general.please_select_ellipsis'),
        value: -1,
    }

    @observable embed = false

    @observable intercept = false

    @observable qr = false

    @observable campaignId = 0

    @observable domain = ''

    @observable password =''

    @observable disableMobileDisplayMode = false

    @observable kioskSettings = {
        redirectAfterTime: 0,
        redirectAfterTimeOnCompletion: 0,
        showRestartButtonAfterTime: 0,
        showRestartPopupAfterTime: 0,
    }

    editingCampaign = false

    modalStyle = {}

    @observable showInterceptRulesModal = false

    constructor(store, surveyId, history) {
        makeObservable(this)
        this.store = store
        this.selectedStatusFilter = this.defaultStatusFilter
        this.history = history
        this.surveyId = surveyId
        this.selectedEmailSendDateTime = moment(this.selectedEmailSendDateTime).tz(store.timeZone)
        this.selectedQuestion = this.defaultSelectedQuestion
        this.gatewayUrl = this.getGatewayUrl(window.location.hostname)
    }

    get languages() {
        return [
            {
                label: i18n.t('form.general.please_select_ellipsis'),
                value: -1,
            },
            ...R.pathOr([], ['metadata', 'locales'], this.store.survey).map((locale) => ({
                value: locale,
                label: this.store.clientLocales[locale],
            })),
        ]
    }

    init = async (tab) => {
        if (this.store.survey && typeof this.store.survey.getProductName === 'function') {
            this.emailSender = this.store.survey.getProductName(this.store.productLocales)
        }

        const mergeFields = await this.store.http.get('/mergefields')
        this.store.mergeFields = mergeFields.reduce((arr, mergeField) => {
            const title = i18n.t(`merge_field_${mergeField.code}`)
            if (!title.match(/merge_field_/)) {
                arr.push({
                    title,
                    code: mergeField.code,
                })
            }
            return arr
        }, [])

        if (R.path(['survey', 'metadata', 'productInfo', 'productId'], this.store)) {
            this.getProduct(this.store.survey.metadata.productInfo.productId)
        }

        if (this.store.hasMandatoryQuestions()) {
            this.missingMandatoryQuestions = true
            this.history.push(`/survey/${this.surveyId}/setup`)
        }

        if (!this.surveyQuestions.length) {
            this.loadSurvey(this.surveyId)
        }

        await this.getEmailData()

        this.activeTab = tab
    }

    getEmailData = async () => {
        await Promise.all([
            this.getTemplates(),
            this.getLists(),
            this.getSchedules(),
            this.getUsers(),
            this.selectAll = false,
            this.getEmailSchedules(),
        ])
    }

    // MODAL CONTROLS
    hideAllModals = () => {
        this.emailListModalVisible = false
        this.addToQuestionModalVisible = false
        this.completionModalVisible = false
        this.previewModalVisible = false
        this.createUserModalVisible = false
        this.deleteSelectedModalVisible = false
        this.emailListMergeFieldModalVisible = false
        this.errorModalVisible = false
    }

    showDeleteSelectedModal = () => {
        this.deleteSelectedModalVisible = true
    }

    hideDeleteSelectedModal = () => {
        this.deleteSelectedModalVisible = false
    }

    showErrorModal = () => {
        this.hideAllModals()
        this.errorModalVisible = true
    }

    hideErrorModal = () => {
        this.errorModalVisible = false
        this.errorMsg = ''
        this.errorType = ''
        if (this.socket) {
            this.socket.disconnect()
            this.socket = null
        }
    }

    showEmailListModal = () => {
        this.uploadDelimiter = 'comma'
        this.activeTab = 'listusers'
        this.emailListModalVisible = true
    }

    hideEmailListModal = () => {
        this.emailListModalVisible = false
        this.confirmationChecked = false
    }

    closeEmailListModal = () => {
        this.hideEmailListModal()
        this.socket.disconnect()
        this.socket = null
    }

    showAddToQuestionModal = () => {
        this.addToQuestionModalVisible = true
    }

    hideAddToQuestionModal = () => {
        this.addToQuestionModalVisible = false
    }

    showCompletionModal = () => {
        this.completionModalVisible = true
    }

    hideCompletionModal = () => {
        this.completionModalVisible = false
    }

    showPreviewModal = () => {
        this.previewModalVisible = true
    }

    hidePreviewModal = () => {
        this.previewModalVisible = false
        this.importProcessing = false
    }

    showDownloadModal = () => {
        this.downloadModalVisible = true
    }

    hideDownloadModal = () => {
        this.downloadModalVisible = false
        this.userDownloadUrl = ''
        this.downloadDelimiter = ''
        this.downloadType = ''
    }

    showDeleteListModal = () => {
        this.deleteListModalVisible = true
    }

    hideDeleteListModal = () => {
        this.listToDelete = null
        this.deleteListModalVisible = false
    }

    showCreateUserModal = () => {
        this.createUserModalVisible = true
    }

    hideCreateUserModal = () => {
        this.createUserModalVisible = false
        this.prePopulatedResponses = observable.map({})
        this.userData = {
            email: '',
            salutation: '',
            firstName: '',
            lastName: '',
            jobTitle: '',
            companyName: '',
        }

        this.selectedCreateUserList = {
            label: 'Please select...',
            value: '',
        }
    }

    showEmailListWarningModal = () => {
        this.emailListWarningModalVisible = true
    }

    hideEmailListWarningModal = () => {
        this.emailListWarningModalVisible = false
    }

    showSendFromWarningModal = () => {
        this.sendFromWarningModalVisible = true
    }

    hideSendFromWarningModal = () => {
        this.sendFromWarningModalVisible = false
    }

    showCreateEmailModal = () => {
        this.activeTab = 'builder'
        this.createEmailModalVisible = true
    }

    hideCreateEmailModal = () => {
        this.createEmailModalVisible = false
    }

    showTestEmailModal = () => {
        this.testEmailModalVisible = true
    }

    hideTestEmailModal = () => {
        this.testEmailModalVisible = false
    }

    showSurveyLinkWarningModal = () => {
        this.surveyLinkWarningModalVisible = true
    }

    hideSurveyLinkWarningModal = () => {
        this.surveyLinkWarningModalVisible = false
    }

    showOptOutLinkWarningModal = () => {
        this.optOutLinkWarningModalVisible = true
    }

    hideOptOutLinkWarningModal = () => {
        this.optOutLinkWarningModalVisible = false
    }

    showScheduleEmailModal = () => {
        this.scheduleEmailModalVisible = true
    }

    hideDeleteUsersFromListModal = () => {
        this.deleteUsersFromListModalVisible = false
    }

    showDeleteUsersFromListModal = (list) => {
        this.listToDelete = list

        if (list.usercount === 0) {
            this.deleteListModalVisible = true
            return
        }

        this.deleteUsersFromListModalVisible = true
    }

    hideDeleteUsersFromListConfirmationModal = () => {
        this.listToDelete = null
        this.usersToDelete = []
        this.usersToDeleteCount = 0
        this.deleteUsersFromListConfirmationModalVisible = false
    }

    showDeleteUsersFromListConfirmationModal = () => {
        this.deleteUsersFromListConfirmationModalVisible = true
    }

    hideScheduleEmailModal = () => {
        this.scheduleEmailModalVisible = false
    }

    showSendNowModal = () => {
        this.sendNowModalVisible = true
    }

    hideSendNowModal = () => {
        this.sendNowModalVisible = false
    }

    showVerificationWarningModal = () => {
        this.verificationWarningModalVisible = true
    }

    hideVerificationWarningModal = () => {
        this.verificationWarningModalVisible = false
    }

    showWizardEmailModal = () => {
        this.wizardEmailModalVisible = true
    }

    hideWizardEmailModal = () => {
        this.wizardEmailModalVisible = false
    }

    showEmailListMergeFieldModal = () => {
        this.emailListMergeFieldModalVisible = true
    }

    hideEmailListMergeFieldModal = () => {
        this.emailListMergeFieldModalVisible = false
        this.importProcessing = false
    }

    closeEmailListMergeFieldModal = () => {
        this.emailListMergeFieldModalVisible = false
        this.importProcessing = false

        if (this.socket) {
            this.socket.disconnect()
            this.socket = null
        }
    }

    showCreateEmailListModal = () => {
        this.createEmailListModalVisisble = true
    }

    hideCreateEmailListModal = () => {
        this.createEmailListModalVisisble = false
        this.importProcessing = false
    }

    showCampaignModal = () => {
        if (this.campaignId !== 0) {
            this.getCampaign()
        }

        this.campaignModalVisible = true
    }

    showDeleteModal = (itemId) => {
        this.deleteModalItem = itemId
        this.deleteModalData = this.modalDataMap[this.campaignType]
        this.deleteModalVisisble = true
    }

    closeDeleteModal = () => {
        this.deleteModalVisisble = false
    }

    showKioskSettingsModal = () => {
        const {
            adminConsole: { kioskSettings, password },
            displaySettings: { disableMobileDisplayMode },
        } = this.store.survey.metadata

        this.password = password
        this.kioskSettings = kioskSettings
        this.disableMobileDisplayMode = disableMobileDisplayMode
        this.kioskSettingsModalVisible = true
    }

    closeKioskSettingsModal = () => {
        this.kioskSettingsModalVisible = false
        this.password = ''
        this.disableMobileDisplayMode = false
        this.kioskSettings = {
            redirectAfterTime: 0,
            redirectAfterTimeOnCompletion: 0,
            showRestartButtonAfterTime: 0,
            showRestartPopupAfterTime: 0,
        }
    }

    deleteListModalContinue = async () => {
        await this.deleteList()
        this.hideDeleteListModal()
    }

    // ACCORDION CONTROLS
    toggleUploadStatsAccordion = () => {
        this.uploadStatsAccordionOpen = !this.uploadStatsAccordionOpen
    }

    togglePreviewDataAccordion = (accordion) => {
        if (this.previewDataAccordionOpen === accordion) {
            this.previewDataAccordionOpen = ''
        } else {
            this.previewDataAccordionOpen = accordion
        }
    }

    toggleUploadInfoAccordion = () => {
        this.uploadInfoAccordionOpen = !this.uploadInfoAccordionOpen
    }

    // TAB CONTROLS
    handleChangeTab = (tab) => {
        if (this.activeTab === tab) return

        this.activeTab = tab
    }

    // CHECKBOX CONTROLS
    toggleSelectAll = () => {
        this.selectAll = !this.selectAll

        if (this.selectAll) {
            this.selectedUsers = this.userList.map((user) => user.surveyuserid_txt)
        } else {
            this.selectedUsers = []
        }
    }

    toggleConfirmationChecked = () => {
        this.confirmationChecked = !this.confirmationChecked
    }

    selected = (e, value) => {
        if (e.value) {
            this.selectedUsers.push(value.surveyuserid_txt)
        } else {
            this.selectedUsers = this.selectedUsers.filter((id) => id !== value.surveyuserid_txt)
        }
    }

    enableEmailSender = () => {
        this.disableEmailSender = false
    }

    toggleAddReplyTo = () => {
        this.addReplyTo = !this.addReplyTo
        if (!this.addReplyTo) {
            this.emailReplyTo = ''
        }
    }

    toggleEmailTemplate = () => {
        this.saveAsTemplate = !this.saveAsTemplate
    }

    toggleOptOutModalCheckbox = () => {
        this.optOutChecked = !this.optOutChecked
    }

    toggleScheduleEmailCheckbox = () => {
        this.scheduleEmailChecked = !this.scheduleEmailChecked
    }

    // GETTERS
    getEmailBody = () => this.emailBody

    getLists = async () => {
        try {
            const response = await this.store.http.get(`/surveyusers/${this.store.survey.id}/list`)
            const list = response.map((userlist) => ({
                value: userlist.surveyuserlistId,
                label: (userlist.listname) + (this.getVerifyStatus(userlist.verifyState)),
            }))
            this.emailList = response
            this.emailListOptions = list
        } catch (e) {
            console.error(`this.emailList = ${JSON.stringify(this.emailList, null, 4)}`)
        }
    }

    // DATA FETCHING
    getUsers = (from, to) => {
        let url = `/surveyusers/${this.surveyId}`
        let searchString = this.userSearchModule ? this.userSearchModule.searchStr : ''
        if (searchString) {
            searchString = `%${searchString}%`
        }
        this.selectPage = false
        url += `?top=${to}`
        url += `&start=${from}`
        url += `&sdstatus=${this.statusFilters}`
        url += `&optedout=${this.optedOut}`
        url += `&invalid=${this.invalid}`
        url += `&type=${this.userTypes}`
        url += `&filter=${searchString}`
        if (this.selectedEmailSchedule.value !== '') {
            url += `&scheduleid=${this.selectedEmailSchedule.value}`
        }
        if (this.selectedEmailList.value !== '') {
            url += `&userlistid=${this.selectedEmailList.value}`
        }
        this.store.http.get(url)
            .then((response) => {
                this.userList = response.data.map((row) => {
                    const surveyUser = new SurveyUser(row)
                    surveyUser.checked = this.selectAll
                    return surveyUser
                })
                this.optOutCount = response.optout
                this.invalidCount = response.nonVerified
                this.totalCount = response.total
                this.rowCount = response.rows
                this.filterUserList()
            })
            .catch((e) => {
                console.error(e)
                this.store.addNotification(null, 'Error loading users', 'error')
            })

        return {
            rows: this.userList,
            numRows: this.rowCount,
        }
    }

    loadSurvey = async () => {
        const { store } = this
        const { survey, surveyLocale } = store
        try {
            // const survey = this.store.survey
            // const promises = []
            const questions = await store.http.get(`/api/survey/${survey.id}/questions`)
            const questionPriority = []
            survey.pages.forEach((page) => {
                if (page.questions) {
                    page.questions.forEach((question) => {
                        questionPriority.push(question.questionId.toLowerCase())
                    })
                }
            })
            this.surveyQuestions = questions
                .filter(({ question }) => !['FM', 'NF'].includes(question.questionTypeCode))
                .map(({ pageQuestionId, question }) => {
                    let exploriQuestion = null
                    switch (question.questionTypeCode) {
                        case 'CH':
                            exploriQuestion = new MultipleChoiceQuestion(question)
                            break
                        case 'CO':
                            exploriQuestion = new CountryListQuestion(question)
                            break
                        case 'I':
                            exploriQuestion = new NumericQuestion(question)
                            break
                        case 'OD':
                            exploriQuestion = new PriorityQuestion(question)
                            break
                        case 'PC':
                            exploriQuestion = new PercentageQuestion(question)
                            break
                        case 'RD':
                            exploriQuestion = new SingleChoiceQuestion(question)
                            break
                        case 'RT':
                            exploriQuestion = new RatingQuestion(question)
                            break
                        case 'SB':
                            exploriQuestion = new DropdownListQuestion(question)
                            break
                        case 'ST':
                            exploriQuestion = new StaticText(question)
                            break
                        case 'TA':
                            exploriQuestion = new TextAreaQuestion(question)
                            break
                        case 'TB':
                            exploriQuestion = new GridQuestion(question)
                            break
                        case 'TX':
                            exploriQuestion = new TextBoxQuestion(question)
                            break
                        case 'UV':
                            exploriQuestion = new UrlVariableQuestion(question)
                            break
                        case 'TL':
                            exploriQuestion = new TextBoxListQuestion(question)
                            break
                        case 'SG':
                            exploriQuestion = new SmartGridQuestion(question)
                            break
                        case 'FM':
                            exploriQuestion = new FormQuestion(question)
                            break
                        case 'NF':
                            exploriQuestion = new NumberFormQuestion(question)
                            break
                        case 'DT':
                            exploriQuestion = new DateQuestion(question)
                            break
                        default:
                            exploriQuestion = null
                            break
                    }
                    return {
                        value: pageQuestionId,
                        qOptions: question.optionSet ? question.optionSet.options.map((option) => ({
                            id: option.id,
                            fieldType: option.fieldType,
                            title: option.langs[survey.metadata.defaultLocale] ? option.langs[survey.metadata.defaultLocale].text : '',
                        })) : null,
                        label: `${exploriQuestion.content.getTitleByLocale('shortTitle', surveyLocale, survey.metadata.defaultLocale)} [${this.questionTypeMap[question.questionTypeCode]}]`,
                        pureLabel: exploriQuestion.content.getTitleByLocale('shortTitle', surveyLocale, survey.metadata.defaultLocale),
                        type: question.questionTypeCode,
                        priority: questionPriority.indexOf(question.id.toLowerCase()),
                        oid: question.metadata.oid,
                    }
                }).sort((a, b) => a.priority - b.priority)
        } catch (e) {
            console.error(`failed to load survey ${this.store.survey.id}`, e)
            this.state = 'notFound'
        }
    }

    editUser = async (e, user) => {
        e.preventDefault()

        this.editingUser = user.surveyuserid_txt

        const userEmailList = this.emailListOptions
            .find((list) => list.value.replace(/-/g, '') === user.surveyuserlistId)

        this.selectedCreateUserList = userEmailList || this.selectedEmailList

        try {
            const res = await this.store.http.get(`/surveyusers/user/${user.surveyuserid_txt}`)

            this.userData = {
                ...res,
                responseData: {},
            }

            const pageQuestionIds = this.store.survey.pages.reduce((qArray, page) => {
                if (page.questions) {
                    qArray = qArray.concat(page.questions.filter((pq) => pq.hasPrepopulatedData))
                }
                return qArray
            }, []).map((q) => q.id.toUpperCase())

            if (pageQuestionIds.length > 0) {
                const prePopulatedResponses = await this.store.http
                    .post(`/surveyuser/${user.surveyuserid_txt}/prepopulated`, JSON.stringify({
                        pagequestionIds: pageQuestionIds,
                    }))

                prePopulatedResponses.forEach(({ pagequestionId, response }) => {
                    if (!this.prePopulatedResponses.has(pagequestionId)) {
                        this.prePopulatedResponses.set(pagequestionId, [])
                    }
                    this.prePopulatedResponses.get(pagequestionId).push(response)
                })
            }
        } catch (error) {
            console.log(error)
            this.store.addNotification(null, 'Error loading pre-populated data', 'error')
        }
        this.showCreateUserModal()
    }

    getEmailSchedules = (ignoreAll) => {
        this.store.http.get(`/surveyusers/${this.store.survey.id}/emailschedule`)
            .then((response) => {
                const list = response.map((userlist) => ({
                    value: userlist.scheduleid,
                    label: userlist.emailsubject,
                }))
                if (!ignoreAll) {
                    this.emailSchedule = [{
                        value: '',
                        label: 'All',
                    }, ...list]
                } else {
                    this.emailSchedule = list
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    getTemplates = async () => {
        const { store } = this
        const { survey } = store

        const url = `/template/email/${survey.metadata.productInfo.productId}/${survey.metadata.taxonomy.surveyType}/${survey.metadata.taxonomy.respondentType}`

        try {
            let response = []
            if (survey.metadata.productInfo.productId !== undefined) {
                response = await store.http.get(url, store.surveyToken)
            }

            if (response.length === 0) {
                this.emailTemplates = [
                    {
                        value: -1,
                        label: i18n.t('--none--'),
                        isDisabled: true,
                    },
                ]
            } else {
                this.emailTemplates = [
                    ...response.map((template) => ({
                        value: template.id,
                        label: template.subject,
                        body: template.body,
                        sender: template.sender,
                    })),
                ]
            }
        } catch (e) {
            console.error(e)
        }
    }

    getProduct = async (productId) => {
        try {
            const response = await this.store.http.get(`/product/${productId}`)
            if (response[0].status === 5) {
                this.showSetAsTemplate = true
            }
        } catch (e) {
            console.error(e)
        }
    }

    getSchedule = async (cb) => {
        const { store, scheduleId } = this
        const { survey } = store

        try {
            const response = await store.http.get(`/survey/${survey.id}/emailschedule/${scheduleId}`, store.surveyToken)
            const { emailSchedule } = response
            if (emailSchedule) {
                this.banner = emailSchedule.banner
                this.emailBody = emailSchedule.emailbody
                this.emailReplyTo = emailSchedule.emailreplyto
                this.addReplyTo = this.emailReplyTo.length !== 0
                this.emailSender = emailSchedule.emailsender
                this.emailSubject = emailSchedule.emailsubject
                this.emailSendDateTime = emailSchedule.senddatetime
                this.scheduleStatus = emailSchedule.schedulestatus
                if (emailSchedule.senddatetime) {
                    this.selectedEmailSendDateTime = moment.utc(this.emailSendDateTime).tz(store.timeZone)
                    this.selectedEmailSendDateTimeText = this.selectedEmailSendDateTime.format('DD/MM/YYYY HH:mm')
                } else {
                    this.selectedEmailSendDateTime = undefined
                    this.selectedEmailSendDateTimeText = ''
                }
                this.template = emailSchedule.template
                this.scheduleStatus = emailSchedule.schedulestatus
                this.loaded = true
                if (cb) {
                    cb()
                }
            } else {
                this.emailSender = survey.getProductName(store.productLocales)
                if (cb) {
                    cb()
                }
            }
        } catch (e) {
            console.error(e)
            if (cb) {
                cb(e)
            }
        }
    }

    getScheduleData = async () => {
        const { survey } = this.store
        if (!survey.id) return []
        let url = `/survey/${survey.id}/emailschedules`
        url += '?skip=300'
        if (this.listsFilterText) {
            url += `&filter=${this.listsFilterText}`
        }
        return this.store.http.get(url, this.store.surveyToken)
    }

    getDeliveryReport = async () => {
        const { survey } = this.store
        if (!survey.id) return []
        const url = `/survey/${survey.id}/deliveryreport`
        return this.store.http.get(url, this.store.surveyToken)
    }

    getSchedules = async () => {
        const [schedules, deliveryReport] = await Promise.all([
            this.getScheduleData(),
            this.getDeliveryReport(),
        ])

        const sanitizedSchedules = []

        for (let i = 0; i < schedules.length; i += 1) {
            const found = sanitizedSchedules
                .find((sch) => sch.scheduleid === schedules[i].scheduleid)

            if (found) {
                found.listname.push(schedules[i].listname)
            } else {
                const sanitized = {
                    ...schedules[i],
                    listname: schedules[i].listname ? [schedules[i].listname] : [],
                }

                sanitizedSchedules.push(sanitized)
            }
        }

        this.filteredListList = sanitizedSchedules
        this.scheduleList = sanitizedSchedules
        this.deliveryReport = deliveryReport
        this.hasDeliveryReport = Object.keys(deliveryReport).includes('sent')
        this.filterSchedules()
    }

    // SCHEDULE ACTIONS
    pauseSending = async () => {
        const { store, scheduleId } = this
        const { survey } = store

        try {
            await store.http.put(`/survey/${survey.id}/emailschedule/${scheduleId}/pause`, JSON.stringify({}))

            await Promise.all([
                await this.getSchedules(),
                await this.getSchedule(),
            ])
            store.addNotification(null, i18n.t('toasts.pauseSending.success'), 'success')
        } catch (e) {
            console.error(e)
            store.addNotification(null, i18n.t('toasts.pauseSending.error'), 'error')
        }
    }

    resumeSending = async () => {
        const { store, scheduleId } = this
        const { survey } = store

        try {
            await store.http.put(`/survey/${survey.id}/emailschedule/${scheduleId}/schedule`, JSON.stringify({
                sendDateTime: moment.utc(this.selectedEmailSendDateTime).format('YYYY-MM-DD HH:mm:ss'),
                surveyUserListId: this.scheduleUserLists.slice().map((list) => list.value),
            }))

            await Promise.all([
                await this.getSchedules(),
                await this.getSchedule(),
            ])

            store.addNotification(null, i18n.t('toasts.resumeSending.success'), 'success')
        } catch (e) {
            console.error(e)
            store.addNotification(null, i18n.t('toasts.resumeSending.error'), 'error')
        }
    }

    cancelSending = async () => {
        const { store, scheduleId } = this
        const { survey } = store

        try {
            await store.http.put(`/survey/${survey.id}/emailschedule/${scheduleId}/cancel`, JSON.stringify({}))

            await Promise.all([
                await this.getSchedules(),
                await this.getSchedule(),
            ])

            store.addNotification(null, i18n.t('toasts.cancelSchedule.success'), 'success')
        } catch (e) {
            console.error(e)
            store.addNotification(null, i18n.t('toasts.cancelSchedule.error'), 'error')
        }
    }

    saveSchedule = async () => {
        const { store, scheduleId } = this
        const { survey } = store
        const body = {
            scheduleId,
            emailBody: this.emailBody,
            emailReplyTo: this.emailReplyTo,
            emailSender: this.emailSender,
            emailSubject: this.emailSubject,
            template: this.saveAsTemplate,
            resend: false,
            banner: R.or(this.banner, undefined),
            surveyId: survey.id,
            senddatetime: this.selectedEmailSendDateTime,
            schedulestatus: this.scheduleStatus,
        }

        if (!body.senddatetime) {
            Reflect.deleteProperty(body, 'senddatetime')
        }

        if (!body.surveyuserlistid) {
            Reflect.deleteProperty(body, 'surveyuserlistid')
        }

        const method = scheduleId === 0
            ? 'post'
            : 'put'

        try {
            const response = await store.http[method](`/survey/${survey.id}/v2/emailschedule/${scheduleId}`, JSON.stringify(body))
            const toast = i18n.t(scheduleId === 0 ? 'toasts.scheduleCreated.success' : 'toasts.scheduleSaved.success')
            if (this.scheduleId === 0) {
                this.scheduleId = response.scheduleId
            }
            this.disableEmailSender = true
            this.getSchedules()
            store.addNotification(null, toast, 'success')
            if (window.location.pathname.split('/').pop() !== 'email') {
                this.goToEmail()
            }
        } catch (e) {
            console.error(e)
            const toast = i18n.t(scheduleId === 0 ? 'toasts.scheduleSaved.error' : 'toasts.scheduleCreated.error')

            store.addNotification(null, toast, 'error')
        }
    }

    scheduleEmail = async (skipVerificationWarning) => {
        const { store, scheduleId } = this
        const { survey } = store

        if (!this.selectedEmailSendDateTime) {
            return
        }

        if (!this.scheduleUserLists.length) {
            return
        }

        if (this.scheduleUserLists.find((list) => list.label.includes('(Not verified)')) && !skipVerificationWarning) {
            this.showVerificationWarningModal()
            return
        }

        try {
            await store.http.put(`/survey/${survey.id}/emailschedule/${scheduleId}/schedule`, JSON.stringify({
                sendDateTime: moment.utc(this.selectedEmailSendDateTime).format('YYYY-MM-DD HH:mm:ss'),
                surveyUserListId: this.scheduleUserLists.slice().map((list) => list.value),
            }))
            await this.getSchedules()

            store.addNotification(null, i18n.t('toasts.schedule.success'), 'success')
            this.hideScheduleEmailModal()
            this.resetValues()
        } catch (e) {
            console.error(e)
            store.addNotification(null, i18n.t('toasts.schedule.error'), 'error')
        }
    }

    sendNow = async () => {
        this.selectedEmailSendDateTime = moment()
        await this.scheduleEmail(false)
        this.hideSendNowModal()
    }

    copySchedule = async (row) => {
        const { store } = this
        const { survey } = store

        try {
            await this.getSchedule()
            await store.http.post(`/survey/${survey.id}/emailschedule/${row.scheduleid}/copy`, JSON.stringify({}), store.surveyToken)
            await this.getSchedules()

            store.addNotification(null, i18n.t('toasts.scheduleCopied.success'), 'success')
        } catch (e) {
            console.error(e)
            store.addNotification(null, i18n.t('toasts.scheduleCopied.error'), 'error')
        }
    }

    sendTestEmail = async () => {
        const { scheduleId, store } = this

        if (!this.testEmailAddress || this.testEmailAddress.split('@').length !== 2) {
            return
        }

        try {
            await store.http.post(`/emailschedule/${scheduleId}/emailtest`, JSON.stringify({
                to: [this.testEmailAddress],
            }))
            store.addNotification(null, i18n.t('toasts.testEmail.success'), 'success')
        } catch (e) {
            console.error(e)
            store.addNotification(null, i18n.t('toasts.testEmail.error'), 'error')
        } finally {
            this.sendingEmail = false
        }
        this.hideTestEmailModal()
        this.invalidTestEmail = false
        this.testEmailAddress = ''
    }

    upload = async (e) => {
        const { store } = this
        const { survey } = store
        const file = e.target.files[0]
        const allowedTypes = ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'] // SVG removed see https://explori.atlassian.net/browse/EXP-5057
        const maxSize = 2 /** size in MB */
        const sizeMB = file.size / 1000 / 1000

        if (sizeMB > maxSize || allowedTypes.indexOf(file.type) === -1) {
            this.bannerError = true
        } else {
            this.bannerError = false
        }
        this.bannerInput.value = ''

        if (this.bannerError) return

        try {
            const response = await store.http.upload(`/survey/${survey.id}/emailschedule/${this.scheduleId}/banner`, file, {
                fileName: file.name,
            }, store.surveyToken)
            store.addNotification(null, 'Banner uploaded', 'success')
            this.bannerUrl = response.bannerTag
            this.banner = this.bannerUrl
            // this.saveSchedule()
        } catch (error) {
            console.error(error)
            store.addNotification(null, 'Failed to upload banner', 'error')
        }
    }

    removeBanner = async () => {
        const { store } = this
        const { survey } = store
        const oldBanner = this.banner
        try {
            await store.http.delete(`/survey/${survey.id}/emailschedule/${this.scheduleId}/banner`, store.surveyToken, new Map([['fileName', oldBanner]]))
            this.banner = ''
            this.saveSchedule()
        } catch (e) {
            console.error(e)
        }
    }

    // CRUD ACTIONS
    updateOrCreateUser = async () => {
        const valid = this.validateUserData(this.userData)

        if (!valid) return

        try {
            const url = this.editingUser
                ? `/surveyuser/${this.store.survey.id}/${this.editingUser}` : `/surveyuser/${this.store.survey.id}`
            const body = this.editingUser
                ? {
                    ...this.userData,
                    surveyuserlistId: this.selectedCreateUserList.value,
                }
                : {
                    ...this.userData,
                    surveyUserId: 0,
                    surveyuserlistid: this.selectedCreateUserList.value,
                }
            const responseJSON = {}
            this.prePopulatedResponses.forEach((value, key) => {
                responseJSON[key.toLowerCase()] = {
                    type: this.surveyQuestions.find((pq) => pq.value === key).type,
                    value: value.slice(),
                }
            })

            body.responseData = responseJSON
            const successMessage = `Survey user ${this.editingUser ? 'updated' : 'created'}`
            await this.store.http[this.editingUser ? 'put' : 'post'](url, JSON.stringify(body))
                .then(() => {
                    this.store.addNotification(null, successMessage, 'success')
                    this.selectedEmailList = {
                        label: 'Please select...',
                        value: '',
                    }
                    this.getUsers()
                    this.getLists()
                    this.hideCreateUserModal()
                })
        } catch (e) {
            console.log(e)
            const failureMessage = `Failed to ${this.editingUser ? 'update' : 'create'} user`
            this.store.addNotification(null, failureMessage, 'error')
        }
    }

    deleteUser = async (user) => {
        try {
            await this.store.http.post(`/surveyusers/${this.store.survey.id}/delete`, JSON.stringify({ userlistid: [user.surveyuserid_txt] }))
                .then(() => {
                    this.getUsers()
                    this.store.addNotification(null, 'User deleted', 'success')
                })
        } catch (e) {
            this.store.addNotification(null, 'Error deleting user', 'error')
        }
    }

    deleteSelected = async () => {
        try {
            await this.store.http.post(`/surveyusers/${this.store.survey.id}/delete`, JSON.stringify({ userlistid: this.selectedUsers }))
                .then(() => {
                    this.getUsers()
                    this.store.addNotification(null, 'Users deleted', 'success')
                    this.selectAll = false
                    this.selectedUsers = []
                    this.hideDeleteSelectedModal()
                })
        } catch (e) {
            this.store.addNotification(null, 'Error deleting users', 'error')
        }
    }

    // SOCKET
    createSocket = (func, params) => {
        console.log('createSocket called')
        const { store } = this
        const { survey } = store
        this.resetErrors()
        this.gatewayUrl = this.getGatewayUrl(window.location.hostname)
        const protocol = 'wss:'
        const socket = io(`${protocol}//${this.gatewayUrl}`, {
            query: `surveyId=${this.store.survey.id}&langcode=${survey.metadata.defaultLocale}&userId=${store.tokenData.userId}&sessionId=${store.userData.sessionId}&csvDelimiter=${this.uploadDelimiter}&validate=${this.verifyEmail}&token=${store.token}`,
        })
        socket.on('connection', () => {
            console.log('connected', this.socket)
            this.socket = socket
            this.startPing()
            func(params)
        })
        socket.on('response', (data) => {
            const jsonData = JSON.parse(data)
            const { kind } = jsonData
            console.log('response', jsonData, this.state)
            if (kind === 'importWarningResponse') return
            if (kind === 'pong') return

            this.importProcessing = false

            if (kind === 'importErrorResponse') {
                this.importErrorSocket(jsonData)
                return
            }

            if (kind === 'CsvValidationError') {
                this.csvValidationErrorSocket(jsonData)
                return
            }

            if (this.state === 'search') {
                this.searchSocket(jsonData)
            } else if (this.state === 'uploaded') {
                this.uploadedSocket(data)
            } else if (this.state === 'preview') {
                this.previewSocket(data)
            }
        })
        // Log errors
        socket.onerror = (error) => {
            this.importProcessing = false
            console.error(`WebSocket Error ${error}`)
            this.socketError = error
            socket.disconnect()
        }

        // Log messages from the server
        // socket.onmessage = function (e) {
        // }
    }

    searchSocket = (jsonData) => {
        this.uploadDetails.clear()
        Object.keys(jsonData).forEach((key) => {
            this.uploadDetails.set(key, jsonData[key])
        })
        const fileTargets = [].concat(this.uploadDetails.get('fileColumns').slice())
        this.uploadDetails.get('dbColumns').forEach((col) => {
            this.columns.set(col, [])
        })
        this.fileTargets = []
        fileTargets.forEach((target) => {
            const name = target.replace(/ /g, '').toLowerCase()
            const dbCol = this.uploadDetails.get('dbColumns').find((col) => col.match(name) || name.match(col))
            if (dbCol) {
                if (this.columns.get(dbCol).length === 0) {
                    this.columns.set(dbCol, [target])
                } else if (dbCol === name) {
                    this.fileTargets.push(this.columns.get(dbCol)[0])
                    this.columns.set(dbCol, [target])
                }
            } else {
                this.fileTargets.push(target)
            }
        })
        this.gdprChecked = false
        this.state = 'uploaded'
        this.importProcessing = false
        this.hideCreateEmailListModal()
        this.showEmailListMergeFieldModal()
    }

    previewSocket = (data) => {
        if (this.pageUpdate) {
            try {
                this.importDetails = JSON.parse(data)
            } catch (e) {
                console.error(data)
                return
            }
            this.rowCount = this.importDetails.numSurveyUsers
            this.pageCount = Math.ceil(this.rowCount / this.rowLimit.value)
            this.windowCount = Math.floor(this.pageCount / this.pageLimit)
            this.pageUpdate = false
        } else {
            this.state = 'result'
            try {
                this.socket.disconnect()
            } catch (e) {
                console.error(e)
            }
            this.socket = null
            // this.refreshPrepopulated()
            this.importDetails = JSON.parse(data)
            this.getUsers()
            this.getLists()
            this.hidePreviewModal()
            this.showCompletionModal()
        }
    }

    uploadedSocket = (data) => {
        this.listName = ''
        try {
            const message = JSON.parse(data)
            if (message.importId) {
                this.importDetails = message
            } else {
                this.errorType = 'questionOptions'
                this.errorDetails = message
                this.state = 'importError'
                throw 'importError'
            }
        } catch (e) {
            this.errorType = 'generic'
            this.errorMsg = e
            this.state = 'importError'
            return
        }
        this.rowCount = this.importDetails.numSurveyUsers
        this.rowLimit = { value: 50, label: 50 }
        this.pageCount = Math.ceil(this.rowCount / this.rowLimit.value)
        this.windowCount = Math.floor(this.pageCount / this.pageLimit)
        this.hideEmailListMergeFieldModal()
        this.showPreviewModal()
        this.state = 'preview'
    }

    importErrorSocket = (jsonData) => {
        this.errorType = 'generic'
        this.errorMsg = jsonData.error
        this.state = 'importError'
        this.showErrorModal()
    }

    csvValidationErrorSocket = (jsonData) => {
        this.errorType = 'csvValidation'
        this.errorDetails = jsonData
        this.state = 'importError'
        this.showErrorModal()
    }

    download = (downloadType) => {
        const { store } = this
        const delim = this.downloadDelimiter || 'comma'
        this.downloadModalLoading = true

        let query = 'target=export'
        query += `&method=surveyUser&token=${store.token}`

        const wsUrl = this.getGatewayUrl(window.location.hostname)
        const socket = io(`wss://${wsUrl}`, {
            query,
        })

        socket.on('connection', () => {
            socket.emit('data', JSON.stringify(
                {
                    kind: 'surveyUserExport',
                    surveyId: store.survey.id,
                    userId: store.tokenData.userId,
                    sessionId: store.userData.sessionId,
                    delimiter: delim,
                    optout: downloadType === 'optout',
                    invalid: downloadType === 'invalid',
                },
            ))
        })
        socket.on('response', (data) => {
            this.userDownloadUrl = data
            this.downloadModalLoading = false
        })
        // Log errors
        socket.onerror = (error) => {
            console.error(`WebSocket Error ${error}`)
        }
    }

    uploadListFile = async ({ target }) => {
        if (!this.socket) {
            this.createSocket(this.uploadListFile, { target })
        } else {
            const file = target.files[0]
            const allowedTypes = ['application/vnd.ms-excel', 'text/plain', 'text/csv', '']
            const maxSize = 10 /** size in MB */
            const sizeMB = file.size / 1000 / 1000
            if (sizeMB > maxSize) {
                this.store.addNotification(null, ` ${file.name} is larger than maximum of ${maxSize}MB`, 'error')
                return
            }
            if (allowedTypes.indexOf(file.type) === -1 || !file.name.match(/\.csv$/i)) {
                this.store.addNotification(null, ` ${file.name} (${file.type}) is not allowed`, 'error')
                return
            }
            this.importProcessing = true
            this.addedQuestions = []
            this.questionTargets.clear()
            this.addDataImportQuestion()
            this.socket.emit('data', file)
            this.state = 'search'
        }
    }

    import = ({ confirmed = true }) => {
        const { store } = this
        const { survey } = store
        if (!confirmed) {
            this.showGDPR = true
            return
        }
        if (!this.socket) {
            this.createSocket(this.import, confirmed)
        }
        const request = {
            kind: 'surveyUserFieldMappingRequest',
            manualColumnIndexMapping: {},
            columnToPageQuestionMap: [],
            langcode: survey.metadata.defaultLocale,
        }
        this.uploadDetails.get('dbColumns').forEach((col) => {
            if (this.columns.get(col)[0]) {
                request.manualColumnIndexMapping[col] = (this.uploadDetails.get('fileColumns').indexOf(this.columns.get(col)[0]) + 1)
            }
        })

        this.addedQuestions.forEach((pageQuestionId) => {
            const question = this.questionTargets.get(pageQuestionId)
            const obj = {
                pageQuestionId,
                questionType: question.type,
                columns: [],
            }

            R.or(this.columns.get(question.label), []).forEach((q) => {
                obj.columns.push(q)
                request.manualColumnIndexMapping[q] = (this.uploadDetails.get('fileColumns').indexOf(q) + 1)
            })
            if (obj.columns.length > 0) {
                request.columnToPageQuestionMap.push(obj)
            }
        })
        this.importProcessing = true
        this.socket.emit('data', JSON.stringify(request))
    }

    startPing = () => {
        const { socket, stopPing } = this
        this.ping = setInterval(() => {
            if (socket.connected) {
                socket.emit('data', JSON.stringify({ kind: 'ping' }))
            } else {
                stopPing()
            }
        }, 10000)
    }

    stopPing = () => {
        if (this.ping) {
            clearInterval(this.ping)
        }
    }

    previewContinue = () => {
        if (this.listName && this.listName.length > 0) {
            this.importProcessing = true
            this.socket.emit('data', JSON.stringify({ kind: 'confirmSurveyUserImportRequest', listName: this.listName, gdprAccepted: true }))

            // if (window.location.pathname.split('/').pop() !== 'email') {
            //     this.activeTab = 'lists'
            //     this.goToEmail()
            // }
        }
    }

    removeTargetQuestion = (e) => {
        const colId = e.target.dataset.columnid
        const droppableId = e.target.dataset.droppableid
        const colIndex = this.addedQuestions.findIndex((col) => col === colId)
        if (colIndex >= 0) {
            const prevAddedQuestions = this.addedQuestions
            prevAddedQuestions.splice(colIndex, 1)
            this.addedQuestions = [...prevAddedQuestions]
            const mappedHeadings = this.columns.get(droppableId)
            if (mappedHeadings) {
                Array.from(mappedHeadings).forEach((h) => {
                    this.fileTargets.push(h)
                })
            }
        }
    }

    // DRAG HANDLERS
    handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if ((e.type === 'dragenter' || e.type === 'dragover') && !this.dragActive) {
            this.dragActive = true
        } else if (e.type === 'dragleave' && this.dragActive) {
            this.dragActive = false
        }
    }

    handleDragEnd = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.dragActive = false
        this.uploadListFile({ target: { files: e.dataTransfer.files } })
    }

    setDragActive = (value) => {
        this.dragActive = value
    }

    removeItem = (e) => {
        const mappedHeading = e.target.dataset.column
        const fromIndex = parseInt(e.target.dataset.index, 10)
        const prevHeadings = Array.from(this.columns.get(mappedHeading))
        if (prevHeadings.length < 1) return
        // update right side
        const newHeading = prevHeadings.splice(fromIndex, 1)[0]
        const newHeadings = [...prevHeadings]
        this.columns.set(mappedHeading, newHeadings)
        // update left side
        this.fileTargets.push(newHeading)
    }

    onDragEnd = (result) => {
        const { destination, source, draggableId } = result

        if (!destination) {
            return
        }

        const isDraggingBack = destination.droppableId === 'fileTargets'
        if (
            (destination.droppableId === source.droppableId
                && destination.index === source.index)
            || isDraggingBack
        ) {
            return
        }

        const start = source.droppableId === 'fileTargets' ? this.fileTargets : this.columns.get(source.droppableId)
        const finish = this.columns.get(destination.droppableId)

        const startHeadings = Array.from(start)

        startHeadings.splice(source.index, 1)

        const newStart = [
            ...startHeadings,
        ]

        const finishHeadings = Array.from(finish)

        if (finishHeadings.length === 1 && destination.droppableId !== 'fileTargets') return

        finishHeadings
            .splice(destination.index, 0, start.find((heading) => heading === draggableId))

        const newFinish = [
            ...finishHeadings,
        ]

        if (source.droppableId === 'fileTargets') {
            this.fileTargets = newStart
        } else {
            this.columns.set(source.droppableId, newStart)
        }

        if (destination.droppableId === 'fileTargets') {
            this.fileTargets = newFinish
        } else {
            this.columns.set(destination.droppableId, newFinish)
        }
    }

    // SEARCH
    searchLists = () => {
        this.listsFilterText = this.listsSearchModule.searchStr
        this.getSchedules()
    }

    @action
    filterUserList = () => {
        this.filteredUserList = this.userList
    }

    searchUsers = () => {
        this.userFilterText = this.userSearchModule.searchStr
        this.getUsers()
    }

    // MODAL CONTROLS
    closeCreateEmailModal = () => {
        this.resetValues()
        this.hideCreateEmailModal()
    }

    closeScheduleEmailModal = () => {
        this.resetValues()
        this.hideScheduleEmailModal()
    }

    wizardGoToBuilder = () => {
        this.showCreateEmailModal()
        this.wizardEmailModalVisible = false
    }

    wizardGoToLists = () => {
        this.showEmailListModal()
        this.wizardEmailModalVisible = false
    }

    goToScheduleModal = () => {
        if (/[\(\)\[\]{}:,;@]/.test(this.emailSender)) {
            this.showSendFromWarningModal()
            return
        }

        if (!/\[surveylink/.test(this.emailBody)) {
            this.showSurveyLinkWarningModal()
            return
        }

        if (!this.ignoreOptoutWarning && !/optout/i.test(this.emailBody)) {
            this.showOptOutLinkWarningModal()
            return
        }

        if (!this.emailList.length) {
            this.showEmailListWarningModal()
            return
        }
        this.saveSchedule()
        this.hideCreateEmailModal()
        this.showScheduleEmailModal()
    }

    scheduleGoBack = () => {
        this.hideScheduleEmailModal()
        this.scheduleEmailChecked = false
        this.showCreateEmailModal()
    }

    optOutModalContinue = () => {
        this.ignoreOptoutWarning = true
        this.hideOptOutLinkWarningModal()
        this.goToScheduleModal()
    }

    resetValues = () => {
        this.scheduleId = 0
        this.optOutChecked = false
        this.scheduleEmailChecked = false
        this.ignoreOptoutWarning = false
        this.testEmailAddress = ''
        this.emailBody = ''
        this.emailReplyTo = ''
        this.template = ''
        this.scheduleStatus = ''
        this.addReplyTo = false
        this.emailSender = this.store.survey.getProductName(this.store.productLocales)
        this.emailSubject = ''
        this.banner = ''
        this.scheduleUserLists = []
        this.selectedEmailSendDateTime = moment().add(1, 'days').startOf('day').tz(this.store.timeZone)
        this.disableEmailSender = true
    }

    getGatewayUrl = (siteUrl) => {
        const server = siteUrl.split('.')[1]
        let gateway = null
        if (siteUrl.match(/dev/) || siteUrl.match(/staging/)) {
            gateway = 'gateway.staging.explori.com' // `gateway.${server}.explori.com`
        } else if (siteUrl === 'tasks.v3.explori.com') {
            gateway = 'gateway.explori.com'
        } else if (server.match(/qa/)) {
            gateway = 'qa-api.qa.hosting.explori.com'
        } else {
            const paths = siteUrl.split('.')
            paths[0] = 'gateway'
            gateway = paths.join('.')
        }
        return gateway
    }

    getSurveyQuestions = () => {
        const options = this.surveyQuestions.filter((q) => (
            ['RD', 'TX', 'TA'].includes(q.type)
            && !this.addedQuestions.includes(q.value))
            && [6, 7].includes(q.oid))

        return options
    }

    changeSelectedQuestion = (obj) => {
        this.selectedQuestion = obj
    }

    addQuestion = () => {
        const question = Object.assign({}, this.selectedQuestion)

        if (question.value !== -1) {
            this.addedQuestions.push(question.value)
            this.questionTargets.set(question.value, {
                label: question.label,
                type: question.type,
                questions: [],
            })
            this.columns.set(question.label, [])
            this.selectedQuestion = this.defaultSelectedQuestion
            this.hideAddToQuestionModal()
        }
    }

    uploadNewList = () => {
        this.hideAllModals()
        this.stage = 'list'
        if (this.socket) {
            this.socket.disconnect()
            this.socket = null
        }
        this.showEmailListModal()
    }

    createEmailListModalContinue = () => {
        this.uploadEl.click()
    }

    verify = () => {
        this.verifyEmail = this.confirmationChecked
        this.emailListModalLoading = true
        this.showCreateEmailListModal()
        this.hideEmailListModal()
    }

    resetErrors = () => {
        this.errorType = ''
        this.errorDetails = []
        this.errorMsg = ''
    }

    addDataImportQuestion = () => {
        const { store } = this
        const { survey } = store

        const pageQuestions = survey.pages.reduce((pq, page) => {
            if (page.questions) {
                page.questions.forEach((q) => pq
                    .set(q.questionId.toUpperCase(), q.id.toUpperCase()))
            }
            return pq
        }, new Map())

        this.mandatoryQuestions.forEach((question) => {
            if (pageQuestions.has(question.questionId) && question.isDataImport) {
                this.questionTargets.set(pageQuestions.get(question.questionId), {
                    label: `${question.title} [${this.questionTypeMap[question.questionType]}]`,
                    type: question.questionType,
                    questions: [],
                })
                this.addedQuestions.push(pageQuestions.get(question.questionId))
            }
        })
    }

    validateUserData = (data) => {
        if (!data.email.length) return false
        if (this.selectedCreateUserList.value === '') return false
        return true
    }

    continueDeleteUsersFromList = async () => {
        try {
            const res = await this.store.http.post(`/surveyusers/${this.store.survey.id}/count`,
                JSON.stringify({ surveyUserListId: this.listToDelete.surveyuserlistId, sdstatus: this.usersToDelete }))

            this.usersToDeleteCount = res.count
            this.hideDeleteUsersFromListModal()
            this.showDeleteUsersFromListConfirmationModal()
        } catch (e) {
            this.store.addNotification(null, 'Error deleting user', 'error')
        }
    }

    continueDeleteEmptyList = async () => {
        try {
            await this.store.http.post(`/surveyusers/${this.store.survey.id}/deleteList`,
                JSON.stringify({ surveyUserListId: this.listToDelete.surveyuserlistId }))
            this.listToDelete = null
            this.store.addNotification(null, 'Deleted list successfully', 'success')
            this.getLists()
            this.getUsers()
            this.hideDeleteListModal()
        } catch (e) {
            this.store.addNotification(null, 'Error deleting list', 'error')
        }
    }

    confirmDeleteUsersFromList = async () => {
        try {
            await this.store.http.post(`/surveyusers/${this.store.survey.id}/deleteUsers`,
                JSON.stringify({ surveyUserListId: this.listToDelete.surveyuserlistId, sdstatus: this.usersToDelete }))
            this.store.addNotification(null, `Successfully deleted ${this.usersToDeleteCount} users`, 'success')
            this.hideDeleteUsersFromListConfirmationModal()
        } catch (e) {
            this.store.addNotification(null, 'Error deleting users', 'error')
        }
    }

    // ONCHANGE CONTROLS
    changeDownloadType = (value) => {
        this.downloadType = value
    }

    changeUsersToDelete = (users) => {
        if (this.usersToDelete.includes(users)) {
            this.usersToDelete = this.usersToDelete.filter((u) => u !== users)
        } else {
            this.usersToDelete.push(users)
        }
    }

    changeDownloadDelimiter = (value) => {
        this.downloadDelimiter = value
    }

    onInvalidChange = (obj) => {
        this.invalid = obj.value
        this.getUsers()
    }

    onOptedOutChange = (obj) => {
        this.optedOut = obj.value
        this.getUsers()
    }

    onListFilterChange = (status) => {
        if (this.statusFilters.includes(status)) {
            this.statusFilters = this.statusFilters.filter((stat) => stat !== status)
        } else {
            this.statusFilters.push(status)
        }

        this.getUsers()
    }

    createUserOnChange = (e) => {
        const { name, value } = e

        this.userData[name] = value
    }

    listViewOnChangeList = (e) => {
        if (e.value === null) {
            this.selectedEmailList = {
                label: 'Please select...',
                value: '',
            }
        } else {
            this.selectedEmailList = {
                label: e.label,
                value: e.value,
            }
        }

        this.getUsers()
    }

    createUserOnListChange = (e) => {
        this.selectedCreateUserList = {
            label: e.label,
            value: e.value,
        }
    }

    previewListNameOnChange = (e) => {
        this.listName = e.value
    }

    selectUploadFile = () => {
        this.bannerInput.click()
    }

    changeStatusFilter = (status) => {
        this.selectedStatusFilter = status
        this.filteredListList = this.scheduleList

        this.filterSchedules()
    }

    filterSchedules = () => {
        if (this.selectedStatusFilter.value === 'all') return

        if (this.selectedStatusFilter.value === 'draft') {
            this.filteredListList = this.filteredListList.slice()
                .filter((item) => ['', null].includes(item.schedulestatus))
        } else {
            this.filteredListList = this.filteredListList.slice()
                .filter((item) => item.schedulestatus === this.selectedStatusFilter.value)
        }
    }

    changeSendDateTime = (obj) => {
        this.selectedEmailSendDateTime = moment(obj.value).tz(this.store.timeZone)
    }

    changeSendDate = (obj) => {
        const currentDateTime = moment(this.selectedEmailSendDateTime).tz(this.store.timeZone)
        const newDate = moment(obj.value).tz(this.store.timeZone)

        const newDateTime = newDate
            .hour(currentDateTime.hour())
            .minute(currentDateTime.minute())
            .second(currentDateTime.second())
        this.selectedEmailSendDateTime = newDateTime
    }

    changeSendTime = (obj) => {
        const currentDateTime = moment(this.selectedEmailSendDateTime).tz(this.store.timeZone)
        const newTime = moment(obj.value).tz(this.store.timeZone)

        const newDateTime = currentDateTime
            .hour(newTime.hour())
            .minute(newTime.minute())
            .second(newTime.second())
        this.selectedEmailSendDateTime = newDateTime
    }

    changeTestEmailAddress = (e) => {
        this.invalidTestEmail = false
        this.testEmailAddress = e.value

        if (!this.testEmailAddress || !e.value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g)) {
            this.invalidTestEmail = true
        }
    }

    changeEmailBody = (value) => {
        this.emailBody = value
    }

    changeEmailList = (e) => {
        this.scheduleUserLists = e.value
    }

    changeEmailSender = (e) => {
        this.emailSender = e.value
    }

    verificationWarningSchedule = () => {
        this.hideVerificationWarningModal()
        this.scheduleEmail(true)
    }

    getVerifyStatus = (verifyState) => {
        switch (verifyState) {
            case 'complete':
                return ' (Passed verification)'
            case 'failed':
            case 'empty':
            case 'notFound':
                return ' (Failed verification)'
            case 'processing':
            case 'uploaded':
                return ' (Verification processing)'
            default:
                return ' (Not sent for verification)'
        }
    }

    editSchedule = async (row) => {
        this.scheduleId = row.scheduleid
        this.emailSubject = row.emailsubject
        const list = row.listname.map((ln) => this.emailList.find((l) => ln === l.listname))
        this.scheduleUserLists = list.map((ln) => ({ label: (ln.listname) + (this.getVerifyStatus(ln.verifyState)), value: ln.surveyuserlistId }))
        await this.getSchedule()
        this.showCreateEmailModal()
    }

    viewSchedule = async (row) => {
        this.scheduleId = row.scheduleid
        this.emailSubject = row.emailsubject
        this.readOnly = true
        await this.getSchedule()
        this.showCreateEmailModal()
    }

    editorSourceToggle = (isSourceEditing) => {
        this.isEditingSource = isSourceEditing
    }

    changeTemplate = ({ value, body, label, sender }) => {
        if (value === -1) return

        this.emailBody = body
        this.emailSubject = label
        this.emailSender = sender
        this.emailSubjectKey = new Date().getTime()
    }

    changeEmailReplyTo = (e) => {
        this.emailReplyTo = e.value
    }

    changeEmailSubject = (e) => {
        this.emailSubject = e.value
    }

    changePassword = ({ value }) => {
        this.password = value
    }

    redirectAfterTime = ({ value }) => {
        this.kioskSettings.redirectAfterTime = parseInt(value, 10)
    }

    redirectAfterTimeOnCompletion = ({ value }) => {
        this.kioskSettings.redirectAfterTimeOnCompletion = parseInt(value, 10)
    }

    showRestartButtonAfterTime = ({ value }) => {
        this.kioskSettings.showRestartButtonAfterTime = parseInt(value, 10)
    }

    showRestartPopupAfterTime = ({ value }) => {
        this.kioskSettings.showRestartPopupAfterTime = parseInt(value, 10)
    }

    toggleMobileDisplayMode = ({ value }) => {
        this.disableMobileDisplayMode = value
    }

    saveKioskSettings = () => {
        this.store.survey.metadata.adminConsole.kioskSettings = this.kioskSettings
        this.store.survey.metadata.adminConsole.password = this.password
        this.store.survey.metadata.displaySettings.disableMobileDisplayMode = this
            .disableMobileDisplayMode

        try {
            surveyApi.updateSettings({
                adminConsoleEnabled: true,
                adminConsole: this.store.survey.metadata.adminConsole.toJSON(),
                displaySettings: this.store.survey.metadata.displaySettings.toJSON(),
            }, this.store)

            this.closeKioskSettingsModal()
        } catch (e) {
            console.error(e)
        }
    }

    editCampaign = (e, row) => {
        e.preventDefault()

        const { survey } = this.store

        this.editingCampaign = true
        this.campaignId = row.campaignId
        this.campaignTitle = row.campaigntitle
        this.domain = row.domain
        this.campaignLink = survey
            .getCampaignLink(row.uuid, row.langCode, row.useLatestUI)
        this.selectedLocale = this.languages
            .find((locale) => locale.value === row.langCode)
        || {
            value: -1,
            label: i18n.t('form.general.please_select_ellipsis'),
        }

        this.showCampaignModal()
    }

    closeCampaignModal = () => {
        this.editingCampaign = false
        this.campaignId = 0
        this.campaignTitle = ''
        this.domain = ''
        this.selectedLocale = {
            label: i18n.t('form.general.please_select_ellipsis'),
            value: -1,
        }
        this.domainError = false
        this.missingProtocol = false
        this.campaignModalVisible = false
    }

    deleteCampaign = async (rows) => {
        const { store } = this
        const { survey } = store

        if (rows.length === 0) {
            return
        }

        let url = `/survey/${survey.id}/campaigns`
        url += `?campaignIds=${rows.join(',')}`

        try {
            await store.http.delete(url, store.surveyToken)
                .then(() => {
                    store.addNotification(null, i18n.t('distributionDeleteModal.success'), 'success')
                    this.selectedRows = []
                    this.getCampaigns(this.campaignType)
                    this.deleteModalVisisble = false
                    this.deleteModalItem = ''
                })
        } catch (e) {
            store.addNotification(null, i18n.t('distributionDeleteModal.failure'), 'error')
            console.error(e)
        }
    }

    search = () => {
        this.filterText = this.searchModule.searchStr
        this.getCampaigns(this.campaignType)
    }

    changeLocale = (locale) => {
        this.selectedLocale = locale
        this.localeError = locale.value === -1
    }

    updateCampaignTitle = (e) => {
        this.campaignError = false
        this.campaignTitle = e.value
    }

    updateDomain = (e) => {
        this.domainError = false
        this.domain = e.value
    }

    downloadQR = (e, value, campaignUuid) => {
        const a = document.createElement('a')
        a.href = document.getElementById(`qr_${value}`).getAttribute('src')
        a.setAttribute('download', `${campaignUuid}.png`)
        a.click()
    }

    domainMissingProtocol = () => !`${this.domain}`.match(/http(s)?:\/\//gm)

    validDomain = () => {
        let error = false
        try {
            const url = new URL(this.domain)
            error = !url.host.match(/\./gi)
        } catch (err) {
            error = true
            console.error(err)
        }
        return error
    }

    validateDomain = (e) => {
        this.domain = e.value
        this.domainError = this.validDomain()
        this.missingProtocol = this.domainMissingProtocol()

        return !this.domainError && !this.missingProtocol
    }

    @action
    setNavigationActiveTab = () => {
        const tabs = ['email', 'campaign', 'onsite', 'intercept', 'embed', 'qr']

        this.navigationActiveTab = tabs.find((tab) => window.location.pathname.includes(tab)) || ''
    }

    getSurveyEmbedding = async () => {
        const { store } = this

        try {
            const results = await store.http.get(`/survey/${store.survey.id}/embed/`, store.surveyToken)
            Object.keys(results.embed).forEach((k) => {
                if (k === 'qr') {
                    this.qr = Boolean(results.embed[k])
                } else if (k === 'intercept') {
                    this.intercept = Boolean(results.embed[k])
                } else if (k === 'embed') {
                    this.embed = Boolean(results.embed[k])
                }
            })
        } catch (e) {
            console.error(e)
        }
    }

    getCampaign = async () => {
        const { store } = this
        const { survey } = store

        if (this.campaignId <= 0) {
            return
        }

        try {
            const response = await store.http.get(`/survey/${survey.id}/campaign/${this.campaignId}`, store.surveyToken)
            this.campaignLink = survey
                .getCampaignLink(response.uuid, response.langCode, store.useLatestUI)
            this.campaignTitle = response.campaigntitle
            this.domain = response.domain
            this.selectedLocale = this.languages
                .find((locale) => locale.value === response.langCode)
                || {
                    value: -1,
                    label: i18n.t('form.general.please_select_ellipsis'),
                }
        } catch (e) {
            console.error(e)
        }
    }

    getCampaigns = async () => {
        const { survey } = this.store
        let url = `/survey/${survey.id}/campaigns`
        url += `?onsite=${this.campaignType === 'onsite' ? 1 : 0}`
        url += `&type=${this.campaignType}`

        if (this.filterText) {
            url += `&filter=${this.filterText}`
        }

        try {
            const schedules = await this.store.http.get(url, this.store.surveyToken)
            this.filteredList = schedules
            this.state = 'search'
        } catch (e) {
            console.error(e)
        }
    }

    hideCampaign = () => {
        this.showCampaign = false
        this.campaignError = false
        this.localeError = false
        this.domainError = false
        this.campaignType = ''
        this.campaignTitle = ''
        this.domain = ''
        this.selectedLocale = {
            label: i18n.t('form.general.please_select_ellipsis'),
            value: -1,
        }
    }

    goToOnSite = () => {
        if (window.location.pathname.split('/').pop() === 'onsite') return

        const { history, store } = this
        history.push(`/survey/${store.survey.id}/onsite`)
    }

    goToEmail = () => {
        if (window.location.pathname.split('/').pop() === 'email') return

        const { store, history } = this
        const { survey } = store
        history.push(`/survey/${survey.id}/email`)
    }

    goToCampaignLinks = () => {
        if (window.location.pathname.split('/').pop() === 'campaign') return

        const { store, history } = this
        const { survey } = store
        history.push(`/survey/${survey.id}/campaign`)
    }

    goToEmbed = () => {
        if (window.location.pathname.split('/').pop() === 'embed') return

        const { store, history } = this
        const { survey } = store
        history.push(`/survey/${survey.id}/embed`)
    }

    goToIntercept = () => {
        if (window.location.pathname.split('/').pop() === 'intercept') return

        const { store, history } = this
        const { survey } = store
        history.push(`/survey/${survey.id}/intercept`)
    }

    goToQr = () => {
        if (window.location.pathname.split('/').pop() === 'qr') return

        const { store, history } = this
        const { survey } = store
        history.push(`/survey/${survey.id}/qr`)
    }

    validateTitle = (e) => !e.value

    validateLocale = (e) => e.value !== -1

    validateCampaign = () => {
        if (['embed', 'intercept'].includes(this.campaignType)) {
            this.domainError = this.validDomain()
            this.missingProtocol = this.domainMissingProtocol()
        }

        this.campaignError = !this.campaignTitle
        this.localeError = this.selectedLocale.value === -1

        return !this.campaignError
            && !this.localeError
            && !this.domainError
            && !this.missingProtocol
    }

    saveCampaign = async () => {
        const { store } = this
        const { survey } = store

        const onSite = this.campaignType === 'onsite'
        const { campaignType } = this

        const valid = this.validateCampaign()

        if (!valid) return

        const method = this.campaignId === 0 ? 'post' : 'put'

        const body = {
            title: this.campaignTitle,
            type: 1,
            onSite,
            langcode: this.selectedLocale.value,
            campaignType,
            domain: ['intercept', 'embed'].includes(campaignType) ? new URL(this.domain).origin : null,
        }

        if (method === 'put') {
            body.campaignId = this.campaignId
        }

        try {
            await store.http[method](`/survey/${survey.id}/campaign`, JSON.stringify(body), store.surveyToken)
            store.addNotification(null, 'Campaign created', 'success')
            this.getCampaigns(campaignType)

            if (campaignType === 'embed') {
                store.hasEmbed = true
                this.goToEmbed()
            } else if (campaignType === 'intercept') {
                store.hasIntercept = true
                this.goToIntercept()
            } else if (campaignType === 'qr') {
                store.hasQR = true
                this.goToQr()
            } else if (onSite) {
                store.hasOnSite = true
                this.goToOnSite()
            } else {
                store.hascampaign = true
                this.goToCampaignLinks()
            }

            this.closeCampaignModal()
        } catch (e) {
            const error = e.error || 'Request failed'
            console.error(e)
            store.addNotification(null, error, 'error')
        }
    }

    toggleHelperVisible = () => {
        this.helperVisible = !this.helperVisible
    }

    openInterceptRulesModal = (campaignUUID) => {
        this.campaignUUID = campaignUUID
        this.showInterceptRulesModal = true
    }

    closeInterceptRulesModal = () => {
        this.campaignUUID = undefined
        this.showInterceptRulesModal = false
    }

    isRapidSurvey = () => {
        const { store } = this
        const { survey } = store
        return process.env.USE_RAPID_SURVEYS && survey.metadata.isRapidSurvey
    }

    isRapidEmailsEnabled = () => {
        const { store } = this
        return process.env.USE_RAPID_SURVEYS && store.userData.flags.isRapidEmailsEnabled
    }

    getNavigationLinks = () => {
        const { store } = this
        const isRapidSurvey = this.isRapidSurvey()

        return [
            {
                onClick: this.goToEmail,
                name: 'email',
                icon: 'far fa-envelope-open-text',
                label: 'distributionNavigation.emailLists',
                show: true,
                disable: isRapidSurvey && !this.isRapidEmailsEnabled(),
            },
            {
                onClick: this.goToCampaignLinks,
                name: 'campaign',
                icon: 'far fa-link',
                label: 'distributionNavigation.campaignLink',
                show: true,
            },
            {
                onClick: this.goToOnSite,
                name: 'onsite',
                icon: 'far fa-tablet-screen',
                label: 'distributionNavigation.onsite',
                show: true,
                disable: isRapidSurvey,
            },
            {
                onClick: this.goToQr,
                name: 'qr',
                icon: 'far fa-qrcode',
                label: 'distributionNavigation.qrCode',
                show: true,
            },
            {
                onClick: this.goToIntercept,
                name: 'intercept',
                icon: 'far fa-globe',
                label: 'distributionNavigation.websiteIntercept',
                show: store.isExploriAdmin() && !isRapidSurvey,
            },
            {
                onClick: this.goToEmbed,
                name: 'embed',
                icon: 'far fa-globe',
                label: 'distributionNavigation.websiteEmbed',
                show: store.isExploriAdmin() && !isRapidSurvey,
            },
        ].filter(({ show }) => show)
    }
}

export default DistributeStore
